import { render, staticRenderFns } from "./PluginGenericobjectLogement.vue?vue&type=template&id=81739058"
import script from "./PluginGenericobjectLogement.vue?vue&type=script&lang=js"
export * from "./PluginGenericobjectLogement.vue?vue&type=script&lang=js"
import style0 from "./PluginGenericobjectLogement.vue?vue&type=style&index=0&id=81739058&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports